// extracted by mini-css-extract-plugin
module.exports = {"container":"StickyScrollMenu_container__6tvvE","containerIsVisible":"StickyScrollMenu_containerIsVisible__8w_yx"};